// extracted by css-extract-rspack-plugin
export default {"container":"gb9fd","active":"zSy0W","input":"ns8Pt","searchIcon":"vFmXh","closeButton":"jxtuQ z4qKh"};